define('viewModels/TreeNav',[
    'lib/knockout',
    'lib/lodash4',
    'services/routeService',
    'viewModels/ViewModel',
    'services/authService'
], function (ko, _, routeService, ViewModel, authService) {
    'use strict';

    var isActive = function(hash) {
        var regexStr = '^' + hash;
        var match = new RegExp(regexStr).test(routeService.route());
        return match;
    };

    var NavLink = ViewModel.extend(function (info) {
        var self = this;
        self.href = ko.observable(info.href);
        self.textKey = ko.observable(info.textKey);
        self.target = ko.observable(info.target);
        self.subLinks = ko.observableArray();

        var subLinks;
        if (info.subLinks) {
            subLinks = _.map(info.subLinks, function (subLink) {
                return self.subView(NavLink, subLink);
            });
            self.subLinks(subLinks);
        }

        self.hasSubLinks = self.computed(function () {
            return self.subLinks().length > 0;
        });

        self.isActive = ko.computed(function () {
            if (isActive(self.href())) {
                return true;
            } else if (self.subLinks()) {
                return _.some(self.subLinks(), function (subLink) {
                    return subLink.isActive();
                });
            }

            return false;
        });

    });

    var TreeMenu = ViewModel.extend(function (linkData) {
        var self = this;

        self.subLinks = ko.observableArray();

        // Recursively remove links we don't have roles for.
        var filterSubLinks = function (linkData) {
            return _.filter(linkData, function (link) {
                if (link.subLinks) {
                    link.subLinks = filterSubLinks(link.subLinks);
                }

                // hasAnyAuthorization provides filtering for mixed collections of arrays of strings and permission objects
                return _.isEmpty(link.roles) || authService.hasAnyAuthorization(link.roles);
            });
        };

        ko.computed(function() {
            var links = ko.unwrap(linkData);
            var filteredLinksTree = filterSubLinks(_.compact(links));

            // Map each remaining link to a view model.
            var subLinks = _.map(filteredLinksTree, function (link) {
                return self.subView(NavLink, link);
            });

            // The foreach in primaryNav.html is looking at this observable array.
            // Be sure to just change the value, otherwise feature toggles changes
            // will not correctly be reflected, as they can come in post initial render.
            self.subLinks(subLinks);
        });
    });

    return TreeMenu;
});

